import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeoTags, seoForPath } from '../utils/siteMeta';

/** Keeps document title, description, Open Graph, Twitter, and JSON-LD in sync with the route. */
export default function SeoHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    applySeoTags(seoForPath(pathname));
  }, [pathname]);

  return null;
}
